<template>
  <div class="vx-card" id="create-remittance">
    <div class="vx-card__body">
      <form>
        <div
          class="grid sm:grid-cols-2 lg:grid-cols-4 grid-cols-1 items-end gap-y-4 gap-3"
        >
          <div class="">
            <vs-input
              :placeholder="$t('user_displayName')"
              v-model="user_displayName"
              name="user_displayName"
              :label="$t('Creator')"
              readonly="readonly"
            />
          </div>
          <div class="flex-grow relative" style="min-width: 25%">
            <label class="vs-select--label">{{ $t("WarehouseName") }}</label>
            <v-select
              class="m-0"
              label="name"
              name="warehouse"
              :options="allWarehouses"
              v-model="checkOutModel.storeId"
              v-validate="{ required: true }"
              :reduce="(x) => x.id"
              :disabled="setDisabled"
              dir="rtl"
            />
            <span
              class="text-danger text-sm absolute"
              style="top: 105% !important"
              v-show="errors.has('warehouse')"
              >{{ errors.first("warehouse") }}</span
            >
          </div>
          <div class="flex-grow relative">
            <label class="vs-select--label datepicker-lb">{{
              $t("CreationDate")
            }}</label>

            <date-picker
              v-model="checkOutModel.registerClock"
              type="datetime"
              format="jYYYY-jMM-jDD HH:mm:ss"
              display-format="jYYYY-jMM-jDD HH:mm:ss"
              id="date-picker"
              :label="$t('CreationDate')"
              :disabled="setDisabled"
              name="date"
            />
            <span
              class="absolute text-danger text-sm"
              style="top: 105%"
              v-show="errors.has('date')"
              >{{ errors.first("date") }}</span
            >
          </div>
          <div class="flex-grow relative">
            <vs-input
              class="inputx"
              v-model="checkOutModel.automationCode"
              name="automationCode"
              :disabled="setDisabled"
              v-validate="'required'"
              :label="$t('AutomationCode')"
            />
            <span
              class="text-danger text-sm absolute"
              style="top: 105% !important"
              v-show="errors.has('automationCode')"
              >{{ errors.first("automationCode") }}</span
            >
          </div>
          <div class="flex-grow relative mb-3">
            <label class="vs-select--label">{{ $t("AgentName") }}</label>
            <treeselect
              v-model="checkOutModel.partyOwnerId"
              name="name"
              :multiple="false"
              :placeholder="$t('Search')"
              :async="true"
              :load-options="loadSearchAgent"
              @select="SelectAgent"
              v-validate="'required'"
            />
            <span
              class="text-danger text-sm absolute"
              style="top: 105% !important"
              v-show="errors.has('name')"
              >{{ errors.first("name") }}</span
            >
          </div>
          <div
            class="w-full sm:col-span-2 lg:col-span-3 flex justify-start text-center mb-3"
          >
            <ul class="stateAboutSubmitSalePerson">
              <li
                @click="changeStateAboutSubmitSalePerson('SubmitSalePerson')"
                :class="isSalePerson ? 'onStateSubmitSalePerson' : 'opacity-50'"
              >
                <label class="label">ثبت واسطه فروش</label>
              </li>
              <li
                @click="changeStateAboutSubmitSalePerson('notSubmitSalePerson')"
                :class="
                  !isSalePerson ? 'onStateSubmitSalePerson' : 'opacity-50'
                "
              >
                <label class="label">بدون ثبت واسطه فروش</label>
              </li>
            </ul>
          </div>
          <div class="w-full pt-2" v-if="isSalePerson && isSelectAgent">
            <label v-if="isLeastOneSalePerson" class="vs-select--label">{{
              $t("SalePersonName")
            }}</label>
            <v-select
              v-if="isLeastOneSalePerson"
              label="firstName"
              name="SalePersonName"
              :options="salesPersonsNameList"
              :reduce="(x) => x.id"
              v-model="checkOutModel.salePersonId"
              ref="SalePersonName"
              dir="rtl"
              :clearable="false"
              class="m-0"
            >
            </v-select>
            <label v-else for="">این نماینده ، به واسطه فروشی متصل نیست</label>
            <!-- isLeastOneSalePerson -->
          </div>
          <div class="col-span-full w-full">
            <vs-input
              class="inputx"
              v-model="checkOutModel.description"
              :disabled="setDisabled"
              rows="1"
              :label="$t('Description')"
            />
          </div>
          <div class="w-full col-span-full flex justify-end">
            <vs-button
              type="filled"
              class="px-12"
              @click.prevent="level1Submit()"
              v-show="showBtn"
              >{{ $t("Continue") }}</vs-button
            >
          </div>
        </div>
      </form>
      <product-attach
        @detaUpdate="detaUpdate"
        v-show="showForm"
        :storeId="storeId"
      ></product-attach>
      <div class="vx-row" v-show="showForm">
        <div class="w-full">
          <vs-button
            type="filled"
            class="float-right"
            @click.prevent="submitForm"
            :disabled="disabled"
            >{{ $t("Save") }}</vs-button
          >
          <vs-button
            type="filled"
            class="float-right"
            id="reset-btn"
            @click.prevent="resetForm"
            >{{ $t("Reset") }}</vs-button
          >
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
::v-deep .add-btn {
  margin-top: 1.5rem;
}
::v-deep .stateAboutSubmitSalePerson {
  display: inline-flex;
  padding: 0 1em;
  border-radius: 4px;
  margin: 0;
  padding: 0;
  list-style: none;
  border: 1px solid rgb(202, 202, 202);
  background-color: rgb(230, 230, 230);
  height: 3em;
}
::v-deep .label {
  display: inline-block;
  color: black;
  border-radius: 4px;
  transition: all 0.1s ease;
  width: 100%;
  text-align: center;
  align-content: center;
  padding: 10px 20px 0;
  height: 100%;
}

::v-deep #StateSubmitSalePersonId {
  border: 0;
  clip: rect(0, 0, 0, 0);
  height: 1px;
  overflow: hidden;
  padding: 0;
  position: absolute !important;
  white-space: nowrap;
  width: 1px;
}
::v-deep .onStateSubmitSalePerson {
  background-color: #007470;
  & .label {
    color: white;
  }
}
::v-deep .vs-select--label {
  margin-top: 6px;
  margin-bottom: 2px;
  display: block;
}
::v-deep #reset-btn {
  margin-left: 1.5rem;
  background: #3ec9d6 !important;
}
::v-deep .text-danger {
  position: relative;
  top: -10px !important;
}
::v-deep .v-select {
  margin-bottom: 16px;
}
</style>
<script>
import { mapGetters, mapActions, mapState } from "vuex";
import "../../../assets/scss/vuesax-rtl/pages/_warehouse.scss";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import vSelect from "vue-select";
import { Validator } from "vee-validate";
import ProductAttach from "./ProductAttach.vue";
import * as moment from "jalali-moment";
import authService from "../../../auth/authService";
import Treeselect from "@/components/CustomTreeSelect.vue";
import { ASYNC_SEARCH } from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

const dict = {
  custom: {
    warehouse: {
      required: "لطفا نام انبار را انتخاب نمایید.",
    },
    date: {
      required: "لطفا تاریخ ثبت را انتخاب نمایید.",
    },
    automationCode: {
      required: "لطفا کد اتوماسیون را وارد نمایید.",
    },
    cottageNumber: {
      required: "لطفا شماره کوتاژ را وارد نمایید.",
    },
    shipmentNumber: {
      required: "لطفا شماره شیپمنت را وارد نمایید.",
    },
    name: {
      required: "لطفا نام نماینده را وارد نمایید.",
    },
  },
};
Validator.localize("fa", dict);
export default {
  name: "warehouseManagement_CheckOutTransactions_Create",
  components: {
    datePicker: VuePersianDatetimePicker,
    "v-select": vSelect,
    ProductAttach,
    Treeselect,
  },
  data() {
    return {
      salesPersonsNameList: [],
      SalePersonName: "",
      counterItem: [],
      user_displayName: "",
      ownerId: "",
      isSubmitSalePerson: "SubmitSalePerson",
      ...mapState({
        model: "checkOutTransactions/model",
      }),
      onSubmit: true,
      // isSubmitSalePerson: false,
      showForm: false,
      isSalePerson: false,
      isLeastOneSalePerson: true,
      isSelectAgent: false,
      showBtn: true,
      onSearch: true,
      setDisabled: false,
      storeId: "",
      checkOutModel: {
        storeId: null,
        requesterInfoCommand: { requesterId: "1", requesterName: "Admin" },
        registerClock: "",
        automationCode: null,
        checkType: 0,
        description: "",
        cottageNumber: 0,
        shipmentNumber: "",
        inventoryTransactionItemCommands: [],
        partyOwnerId: null,
        salePersonId: null,
      },
      applicants: [],
      disabled: false,
      searchQueryNew: "",
      searchQueryOld: "",
    };
  },

  computed: {
    ...mapGetters({
      allWarehouses: "warehouse/listWithShelves",
      inventoryTransactions: "checkOutTransactions/inventoryTransactions",
    }),
  },
  mounted() {
    this.fetchWarehouses();
    this.calcCurrentTime();
    this.get_displayName();
  },
  methods: {
    async get_displayName() {
      var userInfo = await authService.getUser();
      this.user_displayName = userInfo.profile.nickname;
    },
    ...mapActions({
      fetchWarehouses: "warehouse/fetchList",
      // setModelHeaders: "checkOutTransactions/setModelHeaders",
      createCheckOut: "checkOutTransactions/create",
      searchAgent: "parties/searchAgent",
      searchSalePerson: "parties/searchSalePerson",
      checkSerialsCount: "checkOutTransactions/checkSerialsCount",
    }),
    loadSearchAgent({ action, searchQuery, callback }) {
      this.searchQueryNew = searchQuery;
      this.searchQueryOld = this.searchQueryNew;
      setTimeout(() => {
        this.searchQueryNew = searchQuery;
        if (this.searchQueryOld == this.searchQueryNew) {
          if (action === ASYNC_SEARCH) {
            this.searchAgent(searchQuery).then((r) => {
              const options = [];
              r.forEach(function (element) {
                options.push({
                  label: element.name,
                  id: element.ownerId,
                });
              });
              callback(null, options);
            });
          }
        }
      }, 2000);
    },
    SelectAgent(event) {
      if (this.isSalePerson && this.isSelectAgent && this.ownerId != event.id) {
        this.ownerId = event.id;
        this.getSalePersonList();
      }
      this.ownerId = event.id;
      this.isSelectAgent = true;
    },
    calcCurrentTime() {
      let todayJalali = moment().locale("fa").format("YYYY-M-D hh:mm:ss");
      this.checkOutModel.registerClock = todayJalali;
    },
    detaUpdate(inventoryTransaction) {
      this.checkOutModel.inventoryTransactionItemCommands =
        inventoryTransaction;
    },
    level1Submit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          var Sid = this.checkOutModel.storeId;
          this.storeId = this.checkOutModel.storeId;
          var warhouseArr = this.allWarehouses;
          let selectedWarhouse = warhouseArr.find(
            (selectedWarhouse) => selectedWarhouse.id == Sid
          );
          this.checkOutModel.storeName = selectedWarhouse.name;
          this.setDisabled = true;
          this.showBtn = false;
          this.showForm = true;
        }
      });
    },
    setEmptyCountForSerializable() {
      for (
        let index = 0;
        index < this.checkOutModel.inventoryTransactionItemCommands.length;
        index++
      )
        if (
          this.checkOutModel.inventoryTransactionItemCommands[index]
            .stockType == 1
        ) {
          this.checkOutModel.inventoryTransactionItemCommands[index].count =
            null;
        }
    },
    submitForm() {
      if (this.checkOutModel.inventoryTransactionItemCommands.length == 0) {
        this.$swal({
          position: "center-center",
          type: "warning",
          text: "برای حواله‌ی مذکور محصولی انتخاب نگردیده‌است!",
          showConfirmButton: false,
          timer: 5000,
        });
      } else {
        this.disabled = true;
        this.setEmptyCountForSerializable();
        this.createCheckOut(this.checkOutModel)
          .then(() => {
            setTimeout(() => {
              this.$router.push("/CheckOutTransactions/Index");
            }, 3000);
          })
          .catch(() => {
            this.disabled = false;
          });
      }
    },
    resetForm() {
      this.$router.go(this.$router.currentRoute);
    },
    changeStateAboutSubmitSalePerson(inp) {
      if (inp == "notSubmitSalePerson") {
        this.isSalePerson = false;
      } else {
        this.isSalePerson = true;
      }
    },
    async getSalePersonList() {
      await this.searchSalePerson(this.ownerId).then((r) => {
        if (r.length) {
          this.isLeastOneSalePerson = true;
          this.salesPersonsNameList = r;
        } else {
          this.isLeastOneSalePerson = false;
        }
      });
    },
  },
  watch: {
    isSalePerson() {
      if (this.isSalePerson && this.isSelectAgent) {
        this.getSalePersonList();
      }
    },
    isSelectAgent() {
      if (this.isSalePerson && this.isSelectAgent) {
        this.getSalePersonList();
      }
    },
  },
};
</script>
